import { api } from '@/lib/axios'

export async function AgendaFn() {
  const response = await api.get('agenda')

  return response.data
}
